module.exports = __webpack_public_path__ + "static/media/blurredLastOrder.1505eefd.svg";